const e = {
  free: {
    light: {
      "primary-high-surface": "#2f91ff",
      "primary-medium-surface": "#d5e3ff",
      "primary-low-surface": "#ebf1ff",
      "success-high-surface": "#1fa472",
      "success-medium-surface": "#82f9c0",
      "success-low-surface": "#beffdb",
      "warning-high-surface": "#c48300",
      "warning-medium-surface": "#ffddb2",
      "warning-low-surface": "#ffeedc",
      "error-high-surface": "#ff5071",
      "error-medium-surface": "#ffdadc",
      "error-low-surface": "#ffeced",
      "premium-high-surface": "#a078ff",
      "premium-medium-surface": "#e9ddff",
      "premium-low-surface": "#f6edff",
      "neutral-high-surface": "#8791a5",
      "neutral-medium-surface": "#e3e2e2",
      "neutral-low-surface": "#f2f0f0",
      "background-base": "#ffffff",
      "background-overlay": "#0077dd",
      foreground: "#ffffff",
      "foreground-variant-overlay": "#6d778b",
      "hover-and-active-overlay": "#555f71",
      "primary-high-content": "#0077dd",
      "primary-medium-content": "#74adff",
      "primary-low-content": "#a7c8ff",
      "primary-xLow-content": "#d5e3ff",
      "contentOn-primary-high-surface": "#ffffff",
      "success-high-content": "#00885c",
      "success-medium-content": "#45c08b",
      "success-low-content": "#65dca5",
      "success-xLow-content": "#82f9c0",
      "contentOn-success-high-surface": "#ffffff",
      "warning-high-content": "#a26c00",
      "warning-medium-content": "#e79c03",
      "warning-low-content": "#ffb94d",
      "warning-xLow-content": "#ffddb2",
      "contentOn-warning-high-surface": "#ffffff",
      "error-high-content": "#ec0052",
      "error-medium-content": "#ff8796",
      "error-low-content": "#ffb2b9",
      "error-xLow-content": "#ffdadc",
      "contentOn-error-high-surface": "#ffffff",
      "premium-high-content": "#8759ee",
      "premium-medium-content": "#b89bff",
      "premium-low-content": "#d0bcff",
      "premium-xLow-content": "#e9ddff",
      "contentOn-premium-high-surface": "#ffffff",
      "neutral-high-content": "#555f71",
      "neutral-medium-content": "#8791a5",
      "neutral-low-content": "#bdc7dc",
      "neutral-xLow-content": "#e3e2e2",
      "contentOn-neutral-high-surface": "#ffffff",
      "magenta-high-content": "#ad56a7",
      "magenta-medium-content": "#e98adf",
      "magenta-low-content": "#ffaaf4",
      "magenta-xLow-content": "#ffd7f6",
      "violet-high-content": "#8464cf",
      "violet-medium-content": "#b89bff",
      "violet-low-content": "#d0bcff",
      "violet-xLow-content": "#e9ddff",
      "blue-high-content": "#6470c4",
      "blue-medium-content": "#99a5fd",
      "blue-low-content": "#bcc3ff",
      "blue-xLow-content": "#dfe0ff",
      "azure-high-content": "#007fb4",
      "azure-medium-content": "#57b4ed",
      "azure-low-content": "#88ceff",
      "azure-xLow-content": "#c8e6ff",
      "cyan-high-content": "#008587",
      "cyan-medium-content": "#3cbcbf",
      "cyan-low-content": "#5fd8db",
      "cyan-xLow-content": "#7ef5f7",
      "green-high-content": "#1a8856",
      "green-medium-content": "#5bbe87",
      "green-low-content": "#77daa1",
      "green-xLow-content": "#93f7bc",
      "chartreuse-high-content": "#6e7e15",
      "chartreuse-medium-content": "#a2b448",
      "chartreuse-low-content": "#bdd060",
      "chartreuse-xLow-content": "#d9ec79",
      "yellow-high-content": "#9d6e00",
      "yellow-medium-content": "#dba130",
      "yellow-low-content": "#fabc4a",
      "yellow-xLow-content": "#ffdeab",
      "orange-high-content": "#b85e34",
      "orange-medium-content": "#f89061",
      "orange-low-content": "#ffb597",
      "orange-xLow-content": "#ffdbcd",
      "pink-high-content": "#c15268",
      "pink-medium-content": "#ff869b",
      "pink-low-content": "#ffb2bc",
      "pink-xLow-content": "#ffd9dd",
      "magenta-utility": "#cb70c3",
      "violet-utility": "#9e7eec",
      "blue-utility": "#7e8ae0",
      "azure-utility": "#3599d1",
      "cyan-utility": "#00a1a4",
      "green-utility": "#3da26e",
      "chartreuse-utility": "#889930",
      "yellow-utility": "#bd8713",
      "orange-utility": "#d8764a",
      "pink-utility": "#e16b81",
      shadow: "#2f91ff",
      "modal-overlay": "#121c2c",
      white: "#ffffff",
      logo: "#0077dd"
    },
    dark: {
      "primary-high-surface": "#2f91ff",
      "primary-medium-surface": "#004787",
      "primary-low-surface": "#001c3b",
      "success-high-surface": "#1fa472",
      "success-medium-surface": "#005236",
      "success-low-surface": "#002113",
      "warning-high-surface": "#c48300",
      "warning-medium-surface": "#624000",
      "warning-low-surface": "#291800",
      "error-high-surface": "#ff5071",
      "error-medium-surface": "#91002f",
      "error-low-surface": "#400010",
      "premium-high-surface": "#a078ff",
      "premium-medium-surface": "#551aba",
      "premium-low-surface": "#23005c",
      "neutral-high-surface": "#8791a5",
      "neutral-medium-surface": "#3d4759",
      "neutral-low-surface": "#121c2c",
      "background-base": "#1a2434",
      "background-overlay": "#1a2434",
      foreground: "#273142",
      "foreground-variant-overlay": "#ffffff",
      "hover-and-active-overlay": "#ffffff",
      "primary-high-content": "#74adff",
      "primary-medium-content": "#0077dd",
      "primary-low-content": "#005eb1",
      "primary-xLow-content": "#004787",
      "contentOn-primary-high-surface": "#003060",
      "success-high-content": "#45c08b",
      "success-medium-content": "#00885c",
      "success-low-content": "#006c48",
      "success-xLow-content": "#005236",
      "contentOn-success-high-surface": "#003824",
      "warning-high-content": "#e79c03",
      "warning-medium-content": "#a26c00",
      "warning-low-content": "#815500",
      "warning-xLow-content": "#624000",
      "contentOn-warning-high-surface": "#442b00",
      "error-high-content": "#ff8796",
      "error-medium-content": "#ec0052",
      "error-low-content": "#bd0040",
      "error-xLow-content": "#91002f",
      "contentOn-error-high-surface": "#67001f",
      "premium-high-content": "#b89bff",
      "premium-medium-content": "#8759ee",
      "premium-low-content": "#6d3cd3",
      "premium-xLow-content": "#551aba",
      "contentOn-premium-high-surface": "#3c0091",
      "neutral-high-content": "#bdc7dc",
      "neutral-medium-content": "#8791a5",
      "neutral-low-content": "#555f71",
      "neutral-xLow-content": "#3d4759",
      "contentOn-neutral-high-surface": "#273142",
      "magenta-high-content": "#e98adf",
      "magenta-medium-content": "#ad56a7",
      "magenta-low-content": "#913d8c",
      "magenta-xLow-content": "#752373",
      "violet-high-content": "#b89bff",
      "violet-medium-content": "#8464cf",
      "violet-low-content": "#6a4ab4",
      "violet-xLow-content": "#52309b",
      "blue-high-content": "#99a5fd",
      "blue-medium-content": "#6470c4",
      "blue-low-content": "#4b57aa",
      "blue-xLow-content": "#333f90",
      "azure-high-content": "#57b4ed",
      "azure-medium-content": "#007fb4",
      "azure-low-content": "#006590",
      "azure-xLow-content": "#004c6e",
      "cyan-high-content": "#3cbcbf",
      "cyan-medium-content": "#008587",
      "cyan-low-content": "#00696b",
      "cyan-xLow-content": "#004f51",
      "green-high-content": "#5bbe87",
      "green-medium-content": "#1a8856",
      "green-low-content": "#006d42",
      "green-xLow-content": "#005231",
      "chartreuse-high-content": "#a2b448",
      "chartreuse-medium-content": "#6e7e15",
      "chartreuse-low-content": "#576500",
      "chartreuse-xLow-content": "#414c00",
      "yellow-high-content": "#dba130",
      "yellow-medium-content": "#9d6e00",
      "yellow-low-content": "#7d5700",
      "yellow-xLow-content": "#5f4100",
      "orange-high-content": "#f89061",
      "orange-medium-content": "#b85e34",
      "orange-low-content": "#99461e",
      "orange-xLow-content": "#7a2f07",
      "pink-high-content": "#ff869b",
      "pink-medium-content": "#c15268",
      "pink-low-content": "#a23a50",
      "pink-xLow-content": "#83223a",
      "magenta-utility": "#cb70c3",
      "violet-utility": "#9e7eec",
      "blue-utility": "#7e8ae0",
      "azure-utility": "#3599d1",
      "cyan-utility": "#00a1a4",
      "green-utility": "#3da26e",
      "chartreuse-utility": "#889930",
      "yellow-utility": "#bd8713",
      "orange-utility": "#d8764a",
      "pink-utility": "#e16b81",
      shadow: "#000000",
      "modal-overlay": "#121c2c",
      white: "#ffffff",
      logo: "#74adff"
    }
  },
  premium: {
    light: {
      "primary-high-surface": "#a078ff",
      "primary-medium-surface": "#e9ddff",
      "primary-low-surface": "#f6edff",
      "success-high-surface": "#1fa472",
      "success-medium-surface": "#82f9c0",
      "success-low-surface": "#beffdb",
      "warning-high-surface": "#c48300",
      "warning-medium-surface": "#ffddb2",
      "warning-low-surface": "#ffeedc",
      "error-high-surface": "#ff5071",
      "error-medium-surface": "#ffdadc",
      "error-low-surface": "#ffeced",
      "premium-high-surface": "#a078ff",
      "premium-medium-surface": "#e9ddff",
      "premium-low-surface": "#f6edff",
      "neutral-high-surface": "#958da4",
      "neutral-medium-surface": "#e3e2e2",
      "neutral-low-surface": "#f2f0f0",
      "background-base": "#ffffff",
      "background-overlay": "#8759ee",
      foreground: "#ffffff",
      "foreground-variant-overlay": "#7b748a",
      "hover-and-active-overlay": "#625b70",
      "primary-high-content": "#8759ee",
      "primary-medium-content": "#b89bff",
      "primary-low-content": "#d0bcff",
      "primary-xLow-content": "#e9ddff",
      "contentOn-primary-high-surface": "#ffffff",
      "success-high-content": "#00885c",
      "success-medium-content": "#45c08b",
      "success-low-content": "#65dca5",
      "success-xLow-content": "#82f9c0",
      "contentOn-success-high-surface": "#ffffff",
      "warning-high-content": "#a26c00",
      "warning-medium-content": "#e79c03",
      "warning-low-content": "#ffb94d",
      "warning-xLow-content": "#ffddb2",
      "contentOn-warning-high-surface": "#ffffff",
      "error-high-content": "#ec0052",
      "error-medium-content": "#ff8796",
      "error-low-content": "#ffb2b9",
      "error-xLow-content": "#ffdadc",
      "contentOn-error-high-surface": "#ffffff",
      "premium-high-content": "#8759ee",
      "premium-medium-content": "#b89bff",
      "premium-low-content": "#d0bcff",
      "premium-xLow-content": "#e9ddff",
      "contentOn-premium-high-surface": "#ffffff",
      "neutral-high-content": "#625b70",
      "neutral-medium-content": "#958da4",
      "neutral-low-content": "#cbc3db",
      "neutral-xLow-content": "#e3e2e2",
      "contentOn-neutral-high-surface": "#ffffff",
      "magenta-high-content": "#ad56a7",
      "magenta-medium-content": "#e98adf",
      "magenta-low-content": "#ffaaf4",
      "magenta-xLow-content": "#ffd7f6",
      "violet-high-content": "#8464cf",
      "violet-medium-content": "#b89bff",
      "violet-low-content": "#d0bcff",
      "violet-xLow-content": "#e9ddff",
      "blue-high-content": "#6470c4",
      "blue-medium-content": "#99a5fd",
      "blue-low-content": "#bcc3ff",
      "blue-xLow-content": "#dfe0ff",
      "azure-high-content": "#007fb4",
      "azure-medium-content": "#57b4ed",
      "azure-low-content": "#88ceff",
      "azure-xLow-content": "#c8e6ff",
      "cyan-high-content": "#008587",
      "cyan-medium-content": "#3cbcbf",
      "cyan-low-content": "#5fd8db",
      "cyan-xLow-content": "#7ef5f7",
      "green-high-content": "#1a8856",
      "green-medium-content": "#5bbe87",
      "green-low-content": "#77daa1",
      "green-xLow-content": "#93f7bc",
      "chartreuse-high-content": "#6e7e15",
      "chartreuse-medium-content": "#a2b448",
      "chartreuse-low-content": "#bdd060",
      "chartreuse-xLow-content": "#d9ec79",
      "yellow-high-content": "#9d6e00",
      "yellow-medium-content": "#dba130",
      "yellow-low-content": "#fabc4a",
      "yellow-xLow-content": "#ffdeab",
      "orange-high-content": "#b85e34",
      "orange-medium-content": "#f89061",
      "orange-low-content": "#ffb597",
      "orange-xLow-content": "#ffdbcd",
      "pink-high-content": "#c15268",
      "pink-medium-content": "#ff869b",
      "pink-low-content": "#ffb2bc",
      "pink-xLow-content": "#ffd9dd",
      "magenta-utility": "#cb70c3",
      "violet-utility": "#9e7eec",
      "blue-utility": "#7e8ae0",
      "azure-utility": "#3599d1",
      "cyan-utility": "#00a1a4",
      "green-utility": "#3da26e",
      "chartreuse-utility": "#889930",
      "yellow-utility": "#bd8713",
      "orange-utility": "#d8764a",
      "pink-utility": "#e16b81",
      shadow: "#a078ff",
      "modal-overlay": "#1e192b",
      white: "#ffffff",
      logo: "#8759ee"
    },
    dark: {
      "primary-high-surface": "#a078ff",
      "primary-medium-surface": "#551aba",
      "primary-low-surface": "#23005c",
      "success-high-surface": "#1fa472",
      "success-medium-surface": "#005236",
      "success-low-surface": "#002113",
      "warning-high-surface": "#c48300",
      "warning-medium-surface": "#624000",
      "warning-low-surface": "#291800",
      "error-high-surface": "#ff5071",
      "error-medium-surface": "#91002f",
      "error-low-surface": "#400010",
      "premium-high-surface": "#a078ff",
      "premium-medium-surface": "#551aba",
      "premium-low-surface": "#23005c",
      "neutral-high-surface": "#958da4",
      "neutral-medium-surface": "#4a4458",
      "neutral-low-surface": "#1e192b",
      "background-base": "#262133",
      "background-overlay": "#262133",
      foreground: "#332e40",
      "foreground-variant-overlay": "#ffffff",
      "hover-and-active-overlay": "#ffffff",
      "primary-high-content": "#b89bff",
      "primary-medium-content": "#8759ee",
      "primary-low-content": "#6d3cd3",
      "primary-xLow-content": "#551aba",
      "contentOn-primary-high-surface": "#3c0091",
      "success-high-content": "#45c08b",
      "success-medium-content": "#00885c",
      "success-low-content": "#006c48",
      "success-xLow-content": "#005236",
      "contentOn-success-high-surface": "#003824",
      "warning-high-content": "#e79c03",
      "warning-medium-content": "#a26c00",
      "warning-low-content": "#815500",
      "warning-xLow-content": "#624000",
      "contentOn-warning-high-surface": "#442b00",
      "error-high-content": "#ff8796",
      "error-medium-content": "#ec0052",
      "error-low-content": "#bd0040",
      "error-xLow-content": "#91002f",
      "contentOn-error-high-surface": "#67001f",
      "premium-high-content": "#b89bff",
      "premium-medium-content": "#8759ee",
      "premium-low-content": "#6d3cd3",
      "premium-xLow-content": "#551aba",
      "contentOn-premium-high-surface": "#3c0091",
      "neutral-high-content": "#cbc3db",
      "neutral-medium-content": "#958da4",
      "neutral-low-content": "#625b70",
      "neutral-xLow-content": "#4a4458",
      "contentOn-neutral-high-surface": "#332e40",
      "magenta-high-content": "#e98adf",
      "magenta-medium-content": "#ad56a7",
      "magenta-low-content": "#913d8c",
      "magenta-xLow-content": "#752373",
      "violet-high-content": "#b89bff",
      "violet-medium-content": "#8464cf",
      "violet-low-content": "#6a4ab4",
      "violet-xLow-content": "#52309b",
      "blue-high-content": "#99a5fd",
      "blue-medium-content": "#6470c4",
      "blue-low-content": "#4b57aa",
      "blue-xLow-content": "#333f90",
      "azure-high-content": "#57b4ed",
      "azure-medium-content": "#007fb4",
      "azure-low-content": "#006590",
      "azure-xLow-content": "#004c6e",
      "cyan-high-content": "#3cbcbf",
      "cyan-medium-content": "#008587",
      "cyan-low-content": "#00696b",
      "cyan-xLow-content": "#004f51",
      "green-high-content": "#5bbe87",
      "green-medium-content": "#1a8856",
      "green-low-content": "#006d42",
      "green-xLow-content": "#005231",
      "chartreuse-high-content": "#a2b448",
      "chartreuse-medium-content": "#6e7e15",
      "chartreuse-low-content": "#576500",
      "chartreuse-xLow-content": "#414c00",
      "yellow-high-content": "#dba130",
      "yellow-medium-content": "#9d6e00",
      "yellow-low-content": "#7d5700",
      "yellow-xLow-content": "#5f4100",
      "orange-high-content": "#f89061",
      "orange-medium-content": "#b85e34",
      "orange-low-content": "#99461e",
      "orange-xLow-content": "#7a2f07",
      "pink-high-content": "#ff869b",
      "pink-medium-content": "#c15268",
      "pink-low-content": "#a23a50",
      "pink-xLow-content": "#83223a",
      "magenta-utility": "#cb70c3",
      "violet-utility": "#9e7eec",
      "blue-utility": "#7e8ae0",
      "azure-utility": "#3599d1",
      "cyan-utility": "#00a1a4",
      "green-utility": "#3da26e",
      "chartreuse-utility": "#889930",
      "yellow-utility": "#bd8713",
      "orange-utility": "#d8764a",
      "pink-utility": "#e16b81",
      shadow: "#000000",
      "modal-overlay": "#1e192b",
      white: "#ffffff",
      logo: "#b89bff"
    }
  },
  plurall: {
    light: {
      "primary-high-surface": "#ab73ff",
      "primary-medium-surface": "#eddcff",
      "primary-low-surface": "#f8edff",
      "success-high-surface": "#1fa472",
      "success-medium-surface": "#82f9c0",
      "success-low-surface": "#beffdb",
      "warning-high-surface": "#c48300",
      "warning-medium-surface": "#ffddb2",
      "warning-low-surface": "#ffeedc",
      "error-high-surface": "#ff5071",
      "error-medium-surface": "#ffdadc",
      "error-low-surface": "#ffeced",
      "premium-high-surface": "#a078ff",
      "premium-medium-surface": "#e9ddff",
      "premium-low-surface": "#f6edff",
      "neutral-high-surface": "#978ca3",
      "neutral-medium-surface": "#e3e2e2",
      "neutral-low-surface": "#f2f0f0",
      "background-base": "#ffffff",
      "background-overlay": "#9649ff",
      foreground: "#ffffff",
      "foreground-variant-overlay": "#7d7389",
      "hover-and-active-overlay": "#645a70",
      "primary-high-content": "#9649ff",
      "primary-medium-content": "#c197ff",
      "primary-low-content": "#d7baff",
      "primary-xLow-content": "#eddcff",
      "contentOn-primary-high-surface": "#ffffff",
      "success-high-content": "#00885c",
      "success-medium-content": "#45c08b",
      "success-low-content": "#65dca5",
      "success-xLow-content": "#82f9c0",
      "contentOn-success-high-surface": "#ffffff",
      "warning-high-content": "#a26c00",
      "warning-medium-content": "#e79c03",
      "warning-low-content": "#ffb94d",
      "warning-xLow-content": "#ffddb2",
      "contentOn-warning-high-surface": "#ffffff",
      "error-high-content": "#ec0052",
      "error-medium-content": "#ff8796",
      "error-low-content": "#ffb2b9",
      "error-xLow-content": "#ffdadc",
      "contentOn-error-high-surface": "#ffffff",
      "premium-high-content": "#8759ee",
      "premium-medium-content": "#b89bff",
      "premium-low-content": "#d0bcff",
      "premium-xLow-content": "#e9ddff",
      "contentOn-premium-high-surface": "#ffffff",
      "neutral-high-content": "#645a70",
      "neutral-medium-content": "#978ca3",
      "neutral-low-content": "#cec2da",
      "neutral-xLow-content": "#e3e2e2",
      "contentOn-neutral-high-surface": "#ffffff",
      "magenta-high-content": "#ad56a7",
      "magenta-medium-content": "#e98adf",
      "magenta-low-content": "#ffaaf4",
      "magenta-xLow-content": "#ffd7f6",
      "violet-high-content": "#8464cf",
      "violet-medium-content": "#b89bff",
      "violet-low-content": "#d0bcff",
      "violet-xLow-content": "#e9ddff",
      "blue-high-content": "#6470c4",
      "blue-medium-content": "#99a5fd",
      "blue-low-content": "#bcc3ff",
      "blue-xLow-content": "#dfe0ff",
      "azure-high-content": "#007fb4",
      "azure-medium-content": "#57b4ed",
      "azure-low-content": "#88ceff",
      "azure-xLow-content": "#c8e6ff",
      "cyan-high-content": "#008587",
      "cyan-medium-content": "#3cbcbf",
      "cyan-low-content": "#5fd8db",
      "cyan-xLow-content": "#7ef5f7",
      "green-high-content": "#1a8856",
      "green-medium-content": "#5bbe87",
      "green-low-content": "#77daa1",
      "green-xLow-content": "#93f7bc",
      "chartreuse-high-content": "#6e7e15",
      "chartreuse-medium-content": "#a2b448",
      "chartreuse-low-content": "#bdd060",
      "chartreuse-xLow-content": "#d9ec79",
      "yellow-high-content": "#9d6e00",
      "yellow-medium-content": "#dba130",
      "yellow-low-content": "#fabc4a",
      "yellow-xLow-content": "#ffdeab",
      "orange-high-content": "#b85e34",
      "orange-medium-content": "#f89061",
      "orange-low-content": "#ffb597",
      "orange-xLow-content": "#ffdbcd",
      "pink-high-content": "#c15268",
      "pink-medium-content": "#ff869b",
      "pink-low-content": "#ffb2bc",
      "pink-xLow-content": "#ffd9dd",
      "magenta-utility": "#cb70c3",
      "violet-utility": "#9e7eec",
      "blue-utility": "#7e8ae0",
      "azure-utility": "#3599d1",
      "cyan-utility": "#00a1a4",
      "green-utility": "#3da26e",
      "chartreuse-utility": "#889930",
      "yellow-utility": "#bd8713",
      "orange-utility": "#d8764a",
      "pink-utility": "#e16b81",
      shadow: "#ab73ff",
      "modal-overlay": "#1f182a",
      white: "#ffffff",
      logo: "#9649ff"
    },
    dark: {
      "primary-high-surface": "#ab73ff",
      "primary-medium-surface": "#6000be",
      "primary-low-surface": "#280056",
      "success-high-surface": "#1fa472",
      "success-medium-surface": "#005236",
      "success-low-surface": "#002113",
      "warning-high-surface": "#c48300",
      "warning-medium-surface": "#624000",
      "warning-low-surface": "#291800",
      "error-high-surface": "#ff5071",
      "error-medium-surface": "#91002f",
      "error-low-surface": "#400010",
      "premium-high-surface": "#a078ff",
      "premium-medium-surface": "#551aba",
      "premium-low-surface": "#23005c",
      "neutral-high-surface": "#978ca3",
      "neutral-medium-surface": "#4c4357",
      "neutral-low-surface": "#1f182a",
      "background-base": "#282033",
      "background-overlay": "#282033",
      foreground: "#352d40",
      "foreground-variant-overlay": "#ffffff",
      "hover-and-active-overlay": "#ffffff",
      "primary-high-content": "#c197ff",
      "primary-medium-content": "#9649ff",
      "primary-low-content": "#7c26e4",
      "primary-xLow-content": "#6000be",
      "contentOn-primary-high-surface": "#430088",
      "success-high-content": "#45c08b",
      "success-medium-content": "#00885c",
      "success-low-content": "#006c48",
      "success-xLow-content": "#005236",
      "contentOn-success-high-surface": "#003824",
      "warning-high-content": "#e79c03",
      "warning-medium-content": "#a26c00",
      "warning-low-content": "#815500",
      "warning-xLow-content": "#624000",
      "contentOn-warning-high-surface": "#442b00",
      "error-high-content": "#ff8796",
      "error-medium-content": "#ec0052",
      "error-low-content": "#bd0040",
      "error-xLow-content": "#91002f",
      "contentOn-error-high-surface": "#67001f",
      "premium-high-content": "#b89bff",
      "premium-medium-content": "#8759ee",
      "premium-low-content": "#6d3cd3",
      "premium-xLow-content": "#551aba",
      "contentOn-premium-high-surface": "#3c0091",
      "neutral-high-content": "#cec2da",
      "neutral-medium-content": "#978ca3",
      "neutral-low-content": "#645a70",
      "neutral-xLow-content": "#4c4357",
      "contentOn-neutral-high-surface": "#352d40",
      "magenta-high-content": "#e98adf",
      "magenta-medium-content": "#ad56a7",
      "magenta-low-content": "#913d8c",
      "magenta-xLow-content": "#752373",
      "violet-high-content": "#b89bff",
      "violet-medium-content": "#8464cf",
      "violet-low-content": "#6a4ab4",
      "violet-xLow-content": "#52309b",
      "blue-high-content": "#99a5fd",
      "blue-medium-content": "#6470c4",
      "blue-low-content": "#4b57aa",
      "blue-xLow-content": "#333f90",
      "azure-high-content": "#57b4ed",
      "azure-medium-content": "#007fb4",
      "azure-low-content": "#006590",
      "azure-xLow-content": "#004c6e",
      "cyan-high-content": "#3cbcbf",
      "cyan-medium-content": "#008587",
      "cyan-low-content": "#00696b",
      "cyan-xLow-content": "#004f51",
      "green-high-content": "#5bbe87",
      "green-medium-content": "#1a8856",
      "green-low-content": "#006d42",
      "green-xLow-content": "#005231",
      "chartreuse-high-content": "#a2b448",
      "chartreuse-medium-content": "#6e7e15",
      "chartreuse-low-content": "#576500",
      "chartreuse-xLow-content": "#414c00",
      "yellow-high-content": "#dba130",
      "yellow-medium-content": "#9d6e00",
      "yellow-low-content": "#7d5700",
      "yellow-xLow-content": "#5f4100",
      "orange-high-content": "#f89061",
      "orange-medium-content": "#b85e34",
      "orange-low-content": "#99461e",
      "orange-xLow-content": "#7a2f07",
      "pink-high-content": "#ff869b",
      "pink-medium-content": "#c15268",
      "pink-low-content": "#a23a50",
      "pink-xLow-content": "#83223a",
      "magenta-utility": "#cb70c3",
      "violet-utility": "#9e7eec",
      "blue-utility": "#7e8ae0",
      "azure-utility": "#3599d1",
      "cyan-utility": "#00a1a4",
      "green-utility": "#3da26e",
      "chartreuse-utility": "#889930",
      "yellow-utility": "#bd8713",
      "orange-utility": "#d8764a",
      "pink-utility": "#e16b81",
      shadow: "#000000",
      "modal-overlay": "#1f182a",
      white: "#ffffff",
      logo: "#c197ff"
    }
  },
  goStudentLearning: {
    light: {
      "primary-high-surface": "#7088ff",
      "primary-medium-surface": "#dee1ff",
      "primary-low-surface": "#f0efff",
      "success-high-surface": "#50a075",
      "success-medium-surface": "#a2f4c2",
      "success-low-surface": "#c0ffd7",
      "warning-high-surface": "#c18500",
      "warning-medium-surface": "#ffddaf",
      "warning-low-surface": "#ffeedb",
      "error-high-surface": "#ff5540",
      "error-medium-surface": "#ffdad4",
      "error-low-surface": "#ffedea",
      "premium-high-surface": "#907eff",
      "premium-medium-surface": "#e5deff",
      "premium-low-surface": "#f4eeff",
      "neutral-high-surface": "#8d8fa5",
      "neutral-medium-surface": "#e3e2e2",
      "neutral-low-surface": "#f2f0f0",
      "background-base": "#ffffff",
      "background-overlay": "#546de6",
      foreground: "#ffffff",
      "foreground-variant-overlay": "#73768b",
      "hover-and-active-overlay": "#5a5d71",
      "primary-high-content": "#546de6",
      "primary-medium-content": "#95a6ff",
      "primary-low-content": "#b9c3ff",
      "primary-xLow-content": "#dee1ff",
      "contentOn-primary-high-surface": "#ffffff",
      "success-high-content": "#34855c",
      "success-medium-content": "#6bbb8e",
      "success-low-content": "#86d7a8",
      "success-xLow-content": "#a2f4c2",
      "contentOn-success-high-surface": "#ffffff",
      "warning-high-content": "#a06d00",
      "warning-medium-content": "#e49d00",
      "warning-low-content": "#ffba42",
      "warning-xLow-content": "#ffddaf",
      "contentOn-warning-high-surface": "#ffffff",
      "error-high-content": "#dc3b29",
      "error-medium-content": "#ff8a78",
      "error-low-content": "#ffb4a8",
      "error-xLow-content": "#ffdad4",
      "contentOn-error-high-surface": "#ffffff",
      "premium-high-content": "#7661ec",
      "premium-medium-content": "#ac9fff",
      "premium-low-content": "#c8bfff",
      "premium-xLow-content": "#e5deff",
      "contentOn-premium-high-surface": "#ffffff",
      "neutral-high-content": "#5a5d71",
      "neutral-medium-content": "#8d8fa5",
      "neutral-low-content": "#c3c5dd",
      "neutral-xLow-content": "#e3e2e2",
      "contentOn-neutral-high-surface": "#ffffff",
      "magenta-high-content": "#ad56a7",
      "magenta-medium-content": "#e98adf",
      "magenta-low-content": "#ffaaf4",
      "magenta-xLow-content": "#ffd7f6",
      "violet-high-content": "#8464cf",
      "violet-medium-content": "#b89bff",
      "violet-low-content": "#d0bcff",
      "violet-xLow-content": "#e9ddff",
      "blue-high-content": "#6470c4",
      "blue-medium-content": "#99a5fd",
      "blue-low-content": "#bcc3ff",
      "blue-xLow-content": "#dfe0ff",
      "azure-high-content": "#007fb4",
      "azure-medium-content": "#57b4ed",
      "azure-low-content": "#88ceff",
      "azure-xLow-content": "#c8e6ff",
      "cyan-high-content": "#008587",
      "cyan-medium-content": "#3cbcbf",
      "cyan-low-content": "#5fd8db",
      "cyan-xLow-content": "#7ef5f7",
      "green-high-content": "#1a8856",
      "green-medium-content": "#5bbe87",
      "green-low-content": "#77daa1",
      "green-xLow-content": "#93f7bc",
      "chartreuse-high-content": "#6e7e15",
      "chartreuse-medium-content": "#a2b448",
      "chartreuse-low-content": "#bdd060",
      "chartreuse-xLow-content": "#d9ec79",
      "yellow-high-content": "#9d6e00",
      "yellow-medium-content": "#dba130",
      "yellow-low-content": "#fabc4a",
      "yellow-xLow-content": "#ffdeab",
      "orange-high-content": "#b85e34",
      "orange-medium-content": "#f89061",
      "orange-low-content": "#ffb597",
      "orange-xLow-content": "#ffdbcd",
      "pink-high-content": "#c15268",
      "pink-medium-content": "#ff869b",
      "pink-low-content": "#ffb2bc",
      "pink-xLow-content": "#ffd9dd",
      "magenta-utility": "#cb70c3",
      "violet-utility": "#9e7eec",
      "blue-utility": "#7e8ae0",
      "azure-utility": "#3599d1",
      "cyan-utility": "#00a1a4",
      "green-utility": "#3da26e",
      "chartreuse-utility": "#889930",
      "yellow-utility": "#bd8713",
      "orange-utility": "#d8764a",
      "pink-utility": "#e16b81",
      shadow: "#7088ff",
      "modal-overlay": "#171b2c",
      white: "#ffffff",
      logo: "#0b2fac"
    },
    dark: {
      "primary-high-surface": "#7088ff",
      "primary-medium-surface": "#1938b3",
      "primary-low-surface": "#001159",
      "success-high-surface": "#50a075",
      "success-medium-surface": "#005232",
      "success-low-surface": "#002111",
      "warning-high-surface": "#c18500",
      "warning-medium-surface": "#614000",
      "warning-low-surface": "#281800",
      "error-high-surface": "#ff5540",
      "error-medium-surface": "#930200",
      "error-low-surface": "#410100",
      "premium-high-surface": "#907eff",
      "premium-medium-surface": "#4528b8",
      "premium-low-surface": "#1a0064",
      "neutral-high-surface": "#8d8fa5",
      "neutral-medium-surface": "#434659",
      "neutral-low-surface": "#171b2c",
      "background-base": "#202334",
      "background-overlay": "#202334",
      foreground: "#2c2f42",
      "foreground-variant-overlay": "#ffffff",
      "hover-and-active-overlay": "#ffffff",
      "primary-high-content": "#95a6ff",
      "primary-medium-content": "#546de6",
      "primary-low-content": "#3852cb",
      "primary-xLow-content": "#1938b3",
      "contentOn-primary-high-surface": "#00218c",
      "success-high-content": "#6bbb8e",
      "success-medium-content": "#34855c",
      "success-low-content": "#136c45",
      "success-xLow-content": "#005232",
      "contentOn-success-high-surface": "#003921",
      "warning-high-content": "#e49d00",
      "warning-medium-content": "#a06d00",
      "warning-low-content": "#805600",
      "warning-xLow-content": "#614000",
      "contentOn-warning-high-surface": "#432c00",
      "error-high-content": "#ff8a78",
      "error-medium-content": "#dc3b29",
      "error-low-content": "#b82012",
      "error-xLow-content": "#930200",
      "contentOn-error-high-surface": "#680100",
      "premium-high-content": "#ac9fff",
      "premium-medium-content": "#7661ec",
      "premium-low-content": "#5d46d1",
      "premium-xLow-content": "#4528b8",
      "contentOn-premium-high-surface": "#2d009d",
      "neutral-high-content": "#c3c5dd",
      "neutral-medium-content": "#8d8fa5",
      "neutral-low-content": "#5a5d71",
      "neutral-xLow-content": "#434659",
      "contentOn-neutral-high-surface": "#2c2f42",
      "magenta-high-content": "#e98adf",
      "magenta-medium-content": "#ad56a7",
      "magenta-low-content": "#913d8c",
      "magenta-xLow-content": "#752373",
      "violet-high-content": "#b89bff",
      "violet-medium-content": "#8464cf",
      "violet-low-content": "#6a4ab4",
      "violet-xLow-content": "#52309b",
      "blue-high-content": "#99a5fd",
      "blue-medium-content": "#6470c4",
      "blue-low-content": "#4b57aa",
      "blue-xLow-content": "#333f90",
      "azure-high-content": "#57b4ed",
      "azure-medium-content": "#007fb4",
      "azure-low-content": "#006590",
      "azure-xLow-content": "#004c6e",
      "cyan-high-content": "#3cbcbf",
      "cyan-medium-content": "#008587",
      "cyan-low-content": "#00696b",
      "cyan-xLow-content": "#004f51",
      "green-high-content": "#5bbe87",
      "green-medium-content": "#1a8856",
      "green-low-content": "#006d42",
      "green-xLow-content": "#005231",
      "chartreuse-high-content": "#a2b448",
      "chartreuse-medium-content": "#6e7e15",
      "chartreuse-low-content": "#576500",
      "chartreuse-xLow-content": "#414c00",
      "yellow-high-content": "#dba130",
      "yellow-medium-content": "#9d6e00",
      "yellow-low-content": "#7d5700",
      "yellow-xLow-content": "#5f4100",
      "orange-high-content": "#f89061",
      "orange-medium-content": "#b85e34",
      "orange-low-content": "#99461e",
      "orange-xLow-content": "#7a2f07",
      "pink-high-content": "#ff869b",
      "pink-medium-content": "#c15268",
      "pink-low-content": "#a23a50",
      "pink-xLow-content": "#83223a",
      "magenta-utility": "#cb70c3",
      "violet-utility": "#9e7eec",
      "blue-utility": "#7e8ae0",
      "azure-utility": "#3599d1",
      "cyan-utility": "#00a1a4",
      "green-utility": "#3da26e",
      "chartreuse-utility": "#889930",
      "yellow-utility": "#bd8713",
      "orange-utility": "#d8764a",
      "pink-utility": "#e16b81",
      shadow: "#000000",
      "modal-overlay": "#171b2c",
      white: "#ffffff",
      logo: "#ffffff"
    }
  }
};
export {
  e as themes
};
